import { Box, Flex, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextBold, TextMedium, TextRegular, TextWithHighlight } from 'UiKit/typography';
import { Condition } from 'Component/others';
import CountUpNumber from 'Component/count-up';
import { AlertIcon } from 'Asset/icon';

import getPlatformIcon from 'View/host-detail/helper/getPlatformIcon';

import styles from './styles.module.css';

const AchievementCard = ({ name, state, platform, totalDuration, totalViewer, convertionRate, totalBuyer, totalRevenue, key }) => {
  const { t } = useTranslation('host-schedule');
  const platformIcon = getPlatformIcon(platform);

  return (
    <Box className={styles['achievement-card__container']} key={key}>
      <Flex className={styles['head__section']}>
        <TextRegular className={styles['text']}>{name}</TextRegular>
        <TextRegular className={styles['text']}>|</TextRegular>
        <Image src={platformIcon} />
        <TextRegular className={styles['text']}>{platform}</TextRegular>
      </Flex>

      <Flex className={styles['content__section']}>
        <Condition statement={state === 'achievement-unavailable'}>
          <Flex className={styles['achievement-unavailable__container']}>
            <TextBold className={styles['text']}>{t('achievement_card.title_unavailable')}</TextBold>
            <TextRegular className={styles['text']}>{t('achievement_card.description_unavailable')}</TextRegular>
          </Flex>
        </Condition>

        <Condition statement={state === 'achievement-error'}>
          <Box className={styles['achievement-error__container']}>
            <Flex className={styles['achievement-error__box']}>
              <TextBold className={styles['text']}>{t('achievement_card.title_unavailable')}</TextBold>
              <TextRegular className={styles['text']}>{t('achievement_card.description_error')}</TextRegular>
            </Flex>

            <Flex className={styles['contact-us__container']}>
              <AlertIcon size="14px" />
              <TextMedium className={styles['contact-us__text']}> {t('achievement_card.contact_operator')}</TextMedium>
            </Flex>
          </Box>
        </Condition>

        <Condition statement={state === 'achievement-available'}>
          <Box className={styles['achievement-available__container']}>
            <Box className={styles['achievement-available__container--head']}>
              <TextRegular className={styles['sales__text--label']}>{t('achievement_card.label_sales')}</TextRegular>
              <TextBold className={styles['sales__text--value']}>
                <CountUpNumber end={totalRevenue} variant="currency" />
              </TextBold>
            </Box>

            <Box className={styles['achievement-available__container--content']}>
              <Box className={styles['content__item']}>
                <Box>
                  <TextRegular className={styles['content__item--label']}>{t('achievement_card.label_total')}</TextRegular>
                  <TextRegular className={styles['content__item--label']}>{t('achievement_card.label_duration')}</TextRegular>
                </Box>
                <TextBold className={styles['content__item--value']}>
                  <CountUpNumber end={totalDuration} />
                </TextBold>
              </Box>

              <Box className={styles['content__item']}>
                <Box>
                  <TextRegular className={styles['content__item--label']}>{t('achievement_card.label_total')}</TextRegular>
                  <TextRegular className={styles['content__item--label']}>{t('achievement_card.label_buyer')}</TextRegular>
                </Box>
                <TextBold className={styles['content__item--value']}>
                  <CountUpNumber end={totalBuyer} />
                </TextBold>
              </Box>

              <Box className={styles['content__item']}>
                <Box>
                  <TextRegular className={styles['content__item--label']}>{t('achievement_card.label_total')}</TextRegular>
                  <TextRegular className={styles['content__item--label']}>{t('achievement_card.label_viewer')}</TextRegular>
                </Box>
                <TextBold className={styles['content__item--value']}>
                  <CountUpNumber end={totalViewer} />
                </TextBold>
              </Box>

              <Box className={styles['content__item']}>
                <TextRegular className={styles['content__item--label']}>{t('achievement_card.label_earnings')}</TextRegular>
                <TextBold className={styles['content__item--value']}>
                  <CountUpNumber end={convertionRate} uom="%" />
                </TextBold>
              </Box>
            </Box>

            <Box className={styles['achievement-available__container--footer']}>
              <TextWithHighlight
                className={styles['footer__text']}
                text={t('achievement_card.footer_note')}
                textHighlight={t('achievement_card.footer_note_highlight')}
                styleHighlight={{ fontWeight: 700 }}
              />
            </Box>
          </Box>
        </Condition>
      </Flex>
    </Box>
  );
};

export default AchievementCard;
